import { render } from "./datiBaseUser.vue?vue&type=template&id=740a61fe&ts=true"
import script from "./datiBaseUser.vue?vue&type=script&lang=ts"
export * from "./datiBaseUser.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__